import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { $mapLoaded } from '../../models/mapModel/index.js';
import { $activeMetric, $hexagons } from '../../models/logicModel/index.js';
import { $gradientBuckets } from '../../models/gradientModel/index.js';
import { formDynamicBuckets } from '../../utils/hexagon-utils.js';
import { changeLayerVisibility } from '../../utils/mapbox-utils.js';

function HexagonsLayer() {
  const mapLoaded = useUnit($mapLoaded);
  const hexagons = useUnit($hexagons);
  const acitveMetric = useUnit($activeMetric);
  const { buckets, colors } = useUnit($gradientBuckets);

  const createLayer = (update) => {
    const unData = {
      type: 'FeatureCollection',
      features: hexagons,
    };

    const gradientProp = formDynamicBuckets(buckets, colors, 'index');

    console.log('gradientProp', gradientProp);

    if (update) {
      window.map.getSource('un_hexagons_source').setData(unData);
      window.map.setPaintProperty(
        'un_hexagons_layer',
        'fill-color',
        gradientProp
      );
      window.map.setPaintProperty(
        'un_hexagons_outline',
        'line-color',
        gradientProp
      );
    } else {
      if (!window.map.getSource('un_hexagons_source')) {
        window.map.addSource('un_hexagons_source', {
          type: 'geojson',
          data: unData,
        });
      }

      if (!window.map.getLayer('un_hexagons_layer')) {
        window.map.addLayer({
          id: 'un_hexagons_layer',
          type: 'fill',
          source: 'un_hexagons_source',
          paint: {
            'fill-color': gradientProp,
            'fill-opacity': 0.5,
          },
        });

        window.map.addLayer({
          id: 'un_hexagons_outline',
          type: 'line',
          source: 'un_hexagons_source',
          paint: {
            'line-color': gradientProp,
            'line-width': 1,
          },
        });
      }
    }
  };

  useEffect(() => {
    if (mapLoaded && hexagons) {
      if (window.map.getLayer('un_hexagons_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, hexagons, buckets]);

  useEffect(() => {
    if (mapLoaded) {
      if (window.map.getLayer('un_hexagons_layer')) {
        if (acitveMetric === 'flood_ind' || acitveMetric === 'mudflow_ind') {
          changeLayerVisibility('un_hexagons_layer', false);
          changeLayerVisibility('un_hexagons_outline', false);
        } else {
          changeLayerVisibility('un_hexagons_layer', true);
          changeLayerVisibility('un_hexagons_outline', true);
        }
      }
    }
  }, [mapLoaded, acitveMetric]);

  return null;
}

export default HexagonsLayer;
